import {produce} from 'immer';
import {useAtom} from 'jotai';
import {starredBrandsInfoAtom} from '@/map/atom';
import {ToolboxItemProps} from './';
import {ReactComponent as MenuIcon} from './assets/starred.svg';
import {ToolboxItem} from './StyledComponents';

export const StarredBrandButton = (props: ToolboxItemProps) => {
  const [{active}, setMenuInfo] = useAtom(starredBrandsInfoAtom);

  const handleClick = () =>
    setMenuInfo(
      produce((draft) => {
        draft.active = !draft.active;
      })
    );

  return (
    <ToolboxItem {...props} active={active} onClick={handleClick}>
      <MenuIcon />
    </ToolboxItem>
  );
};
